module.exports = __webpack_public_path__ + "img/notshop.e5b30264.png";